import React from 'react';
import Barcode from 'react-barcode';

import logo from 'url:./grilld-white.svg';
import { useFlipOIDC } from '../../components/FlipOIDC';

export interface CardProps {
  title: string;
  prefix?: string;
  className?: string;
}

export default function Card({ className, title, prefix = 'GRH' }: CardProps) {
  const { user } = useFlipOIDC();

  const [id, setId] = React.useState('');

  React.useEffect(() => {
    async function generateId() {
      const encoder = new TextEncoder();
      const data = encoder.encode(user.name);
      const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const value = hashArray.map((b) => String(b)).join('');
      setId(value.substring(0, 7));
    }

    generateId();
  }, [user]);

  return (
    <div className={className}>
      <div className="grilld-card-header">
        <div className="grilld-card-header-logo">
          <img src={logo} alt="Grill'd" />
        </div>
        <div className="grilld-card-header-title">
          {title}
        </div>
      </div>
      <div className="grilld-card-image" />
      <div className="grilld-card-text">
        Membership with Heart
      </div>
      <div className="grilld-card-barcode-spacing">
        <div className="grilld-card-barcode">
          <div className="grilld-card-barcode-code">
            <Barcode value={`${prefix}${id}`} width={2} displayValue={false} height={50} />
          </div>
          <div className="grilld-card-barcode-text">
            {`Member No. ${prefix}${id}`}
          </div>
        </div>
      </div>
      <div className="grilld-card-spacer" />
    </div>
  );
}
